import {useState} from "react";
import {CircularProgress, Box, Typography} from "@mui/material";

const ImageLoader = ({src, alt, sx, maxRetries = 5, retryDelay = 1500, onClick, width, fallbackSrc}) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [retries, setRetries] = useState(0);
    const [imgSrc, setImgSrc] = useState(src);

    const handleError = () => {
        if (retries < maxRetries && imgSrc.indexOf(src) === 0) {
            setRetries((prev) => prev + 1);
            setTimeout(() => setImgSrc(`${src}?retry=${retries + 1}`), retryDelay * ((retries / 5) + 1));
        } else if (imgSrc.indexOf(src) === 0 && fallbackSrc) {
            setRetries(0);
            setImgSrc(`${fallbackSrc}`);
        } else if (retries < maxRetries && imgSrc.indexOf(fallbackSrc) === 0) {
            setRetries((prev) => prev + 1);
            setTimeout(() => setImgSrc(`${fallbackSrc}?retry=${retries + 1}`), retryDelay * ((retries / 5) + 1));
        } else {
            setRetries(0);
            setError(true);
            setLoading(false);
        }
    };

    const handleOnLoad = () => {
        setLoading(false)
    };

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={sx}
            maxWidth={width}
            onClick={onClick}
        >
            {loading && !error && <CircularProgress/>}
            {error && <Typography color="error">Failed to load image</Typography>}
            {!error && (
                <img
                    src={imgSrc}
                    alt={alt}
                    onLoad={handleOnLoad}
                    onError={handleError}
                    style={{display: loading ? "none" : "block", width: "100%", height: "100%", objectFit: "cover"}}
                />
            )}
        </Box>
    );
};

export default ImageLoader;